/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'vs-logs';
const componentName = 'vs-logs-signpost-custom-e2e-timing-header';
const prefix = `${moduleName}.${componentName}`;

export const dataTransferLabel = `${prefix}.dataTransferLabel`;
export const clientRttLabel = `${prefix}.clientRttLabel`;
export const serverRttLabel = `${prefix}.serverRttLabel`;
export const appResponseLabel = `${prefix}.appResponseLabel`;

export const ENGLISH = {
    [dataTransferLabel]: 'Data Transfer',
    [clientRttLabel]: 'Client RTT',
    [serverRttLabel]: 'Server RTT',
    [appResponseLabel]: 'App Response',
};
